import { Box, SvgIcon } from "@mui/material";
import { neutral } from "@flat-ui";
import { ElementType } from "react";

interface Props {
  /** The icon to show */
  icon: ElementType;
}

/** Renders icon for the integrations */
export function IntegrationIcon({ icon }: Props): JSX.Element {
  return (
    <Box
      sx={{
        width: "95px",
        height: "95px",
        backgroundColor: neutral[50],
        display: "grid",
        placeItems: "center",
        borderRadius: "10px",
        boxShadow: `0 1px 0 0 ${neutral[200]}`,
      }}
    >
      <SvgIcon
        inheritViewBox={true}
        component={icon}
        sx={{
          width: "65px",
          height: "65px",
        }}
      />
    </Box>
  );
}
